<!--bolt_48dp_FILL0_wght400_GRAD0_opsz48-->
<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px">
   <path d="M 394.48808,-79.999995 451.63094,-394.28571 H 287.34522 q -16.68571,0 -22,-8.91428 -5.37142,-8.91429 1.77143,-23.20001 L 508.7738,-880 h 57.14286 l -28.57143,314.28572 h 135.71429 q 15.48571,0 21.42857,8.34285 5.94285,8.34286 -2.4,23.77143 L 451.63094,-79.999995 Z"/>
  </svg>
</template>
